import Vue from "vue";
import App from "./App.vue";
import router from "./router/index";
import VueRouter from "vue-router";
import MetaInfo from "vue-meta-info";
import { postGateway } from "./request/index";
import VueAwesomeSwiper from 'vue-awesome-swiper';
import 'swiper/css/swiper.css';
import VueYoutube from 'vue-youtube';
import moment from 'moment';

import {
    Button,
    Select,
    Backtop,
    Breadcrumb,
    Checkbox,
    CheckboxButton,
    CheckboxGroup,
    BreadcrumbItem,
    Dialog,
    Radio,
    RadioGroup,
    Rate,
    Skeleton,
    SkeletonItem,
    Popover,
    Message,
    Carousel,
    CarouselItem,
} from 'element-ui'; // 按需引入 element
Vue.use(Button)
Vue.use(Select)
Vue.use(Backtop)
Vue.use(Breadcrumb)
Vue.use(BreadcrumbItem)
Vue.use(Dialog)
Vue.use(Radio)
Vue.use(RadioGroup)
Vue.use(Rate)
Vue.use(Skeleton)
Vue.use(SkeletonItem)
Vue.use(Popover)
Vue.use(Checkbox);
Vue.use(CheckboxButton);
Vue.use(CheckboxGroup);
Vue.use(Carousel);
Vue.use(CarouselItem);



Vue.use(VueYoutube)
Vue.use(VueAwesomeSwiper)
Vue.use(MetaInfo);
Vue.use(VueRouter);
Vue.config.productionTip = false;
Vue.prototype.$postGateway = postGateway;
Vue.prototype.$moment = moment;
Vue.prototype.$message = Message;


new Vue({
    el: "#app",
    render: (h) => h(App),
    router,
    mounted: () => {
        setTimeout(() => {
            document.dispatchEvent(new Event("render-event"))
        }, 5000);
    },
});